import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import { inject, observer, setDocumentTitle, setUidToken, getlang, setlang } from 'src/helper/devTools.js'
import Toast from '../../../component/Toast'
import { jumpToUser, setTabBar, getDeviceInfo } from 'src/helper/webviewFun.js'
/* import { closeWebViewPage } from 'src/helper/webviewFun.js'
import ReminderBtn from 'src/component/RuleButton'
import LoadingComp from '../../../component/LoadingComp' */
import { history } from 'src/core/router'
import http from 'src/helper/http'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
    setDocumentTitle('AgentRecharge')
  }

  state = {
    uid: 0,
    lang: langM.ar,
    language: 'en',
    setSeachValue: '',
    showEmpty: false,
    seachList: [1],
    hasMore: true,
    scroll: '0,20',
    invtiList: [],
    toastContent: '',
    kw: '',
    seachItemId: null,
    hedinTabar: false
  }
  seachItemId = null
  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en/tr)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })
    try {
      let res = await getDeviceInfo()
    setTabBar('2')
    if (res.res.os && (res.res.os === 'android' || res.res.os === 'ios')) {
      let getVersionFrist = res.res.version.split('.')
      if (getVersionFrist[0] >= 4 && getVersionFrist[1] >= 0) {
        this.setState({ hedinTabar: true })
      }
    }
    } catch (error) {
      
    }
    this.getInvtiList()
  }

  componentDidMount() {}

  fonsue = (e) => {
    let { setSeachValue } = this.state
    this.setState({ showEmpty: e })
  }

  getInvtiList = async () => {
    let { setSeachValue } = this.state
    let res = await http.post('/web/guild/can_invite_fans', { scroll: '0,20', kw: setSeachValue })
    if (res.code == 0) {
      this.setState({
        hasMore: res.res.hasMore,
        scroll: res.res.scroll,
        invtiList: [...res.res.list]
      })
    }
  }

  getLvBg = (e)=>{
    let srt = ''
    if (e == 0) {
       srt = '0'
    }else if (e >0 && e<=9) {
      srt = '09'
    }else if (e >9 && e<=19) {
      srt = '1019'
    }else if (e >19 && e<=29) {
      srt = '2029'
    }else if (e >29 && e<=39) {
      srt = '3039'
    }else if (e >39 && e<=49) {
      srt = '4049'
    }else if (e >49 && e<=59) {
      srt = '5059'
    }else if (e >59 && e<=69) {
      srt = '6069'
    }else if (e >69 && e<=79) {
      srt = '7079'
    }else if (e >79 && e<=89) {
      srt = '8089'
    }else if (e >89 && e<=99) {
      srt = '9099'
    }else if (e == 100) {
      srt = '100'
    }
    return srt
  }

  invtieUser = async (id) => {
    let { lang } = this.state
    let res = await http.post('/web/guild/invite_fans', { invite_uid: id })
    if (res.code == 0) {
      await this.setState({ toastContent: lang.hanleSuc })
      this.refs.toast.hideRule(true)
    } else {
      await this.setState({ toastContent: lang.hanleErr })
      this.refs.toast.hideRule(true)
    }
  }

  handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target
    let { hasMore } = this.state
    if (scrollTop + clientHeight + 30 >= scrollHeight) {
      if (hasMore) return this.addRankingList()
    }
  }

  addRankingList = async () => {
    let { scroll, invtiList, setSeachValue } = this.state
    let res = await http.post('/web/guild/can_invite_fans', { scroll, kw: setSeachValue })
    if (res.code == 0) {
      this.setState({
        invtiList: res.res.list.length && [...invtiList, ...res.res.list],
        scroll: res.res.scroll,
        hasMore: res.res.hasMore
      })
    }
  }
  seachItemId = null
  setSeachValueFn = async (e) => {
    //this.seachItemId && clearTimeout(this.seachItemId)
    this.setState({ setSeachValue: e.target.value })
    /* this.seachItemId = setTimeout(()=>{
            this.getInvtiList()
        },500) */
  }
  handleClearSearchFn = async () => {
    await this.setState({ setSeachValue: '' })
    this.getInvtiList()
    document.querySelector('.getvluaeinput').value = ''
  }
  render() {
    let { hedinTabar, showEmpty, setSeachValue, seachList, invtiList, lang, toastContent, language } = this.state
    return (
      <div className={`invite-member  ${language == 'ar' && 'arlang'}`} >
        <Toast language={language} lang={lang} ref="toast" id="toast" toastContent={toastContent} />
        <div className="nav-top-root">
          {true && <div style={{ width: '6rem', height: '0.44rem', backgroundColor:'#FFFFFF' }} ></div>}
          <div className="nav-top">
            <img
              className="close-view"
              style={{ transform: `${language == 'ar' ? 'rotate(180deg)' : ''}` }}
              src="img/app/newhost/colse_cb.png"
              onClick={() => history.go(-1)}
            ></img>
            <div className="title-name">{lang.invtieText}</div>
          </div>
          <div className="seach-root" style={{ top: `${true ? '1.76rem' : '1.32rem'}` }}>
          <div className="input-root">
            {!showEmpty && setSeachValue.length == 0 && (
              <div className="value-empty">
                <img
                  className="seach-icon"
                  style={{ marginLeft: `${language == 'ar' ? '0.2rem' : ''}` }}
                  src="img/app/newhost/seach_icon.png"
                ></img>
                <div className="text-inrle">{lang.searchPolad}</div>
              </div>
            )}
            {
              <input
                className="getvluaeinput"
                onChange={(e) => this.setSeachValueFn(e)}
                onClick={() => this.fonsue(true)}
                onBlur={() => this.fonsue(false)}
              ></input>
            }
          </div>
          {
            <div
              className="search-btn"
              onClick={() => this.getInvtiList()}
              style={{ color: `${setSeachValue.length == 0 ? '' : '#A47D1C'}` }}
            >
              {lang.searchText}
            </div>
          }
          {false && setSeachValue.length > 0 && (
            <div
              className="search-btn"
              onClick={() => this.handleClearSearchFn()}
              style={{ color: `${setSeachValue.length == 0 ? '' : '#A47D1C'}` }}
            >
              {'Cancel'}
            </div>
          )}
        </div>
        </div>
        <div style={{ height: `${hedinTabar ? '2.56rem' : '2.12rem'}`, width: '3rem' }}></div>
        
        {invtiList.length > 0 && (
          <div className="seach-list" onScroll={(e) => this.handleScroll(e)}>
            {invtiList.map((item, index) => (
              <div className="list-item" key={index}>
                <div className="item-avt">
                  <img className="img-avt" src={item.avatarurl} onClick={() => jumpToUser(item.uid)} />
                  {item.online && <div className="in-line"></div>}
                </div>
                <div className="item-info">
                  <div className="name-madal">
                    <div className="name-text">{item.nickname}</div>
                    {item.gender && item.gender > 0 && (
                      <img
                        className="sex-man"
                        src={item.gender == 2 ? '/img/app/newhost/woman_icon.png' : '/img/app/newhost/boy_icon.png'}
                      />
                    )}
                    <img src={item.countryIcon} className="user-ctry-icon"></img>
                    {item.nobleUrl && <img className="medal-item" src={item.nobleUrl} />}
                    {item.wealthLv > 0 && (
                      <div className="lv-item">
                        <img
                          className="lv-bg-img"
                          src={`/img/app/newhost/wealthLv/icon_wealth_${this.getLvBg(item.wealthLv)}@3x.png`}
                        />
                        <div className="lv-num">{item.wealthLv}</div>
                      </div>
                    )}
                    {item.charmLv > 0 && (
                      <div className="lv-item">
                        <img
                          className="lv-bg-img"
                          src={`/img/app/newhost/charm/icon_charm_${this.getLvBg(item.charmLv)}@2x.png`}
                        />
                        <div className="lv-num">{item.charmLv}</div>
                      </div>
                    )}
                    {false && item.rubyLv > 0 && (
                      <div className="lv-item">
                        <img
                          className="lv-bg-img"
                          src={`/img/app/newhost/ruby/ic_ruby_lv_${this.getLvBg(item.rubyLv, 'reb')}.webp`}
                        />
                        <div className="lv-num">{item.rubyLv}</div>
                      </div>
                    )}
                    {false &&
                      item.medalsIcon.length > 0 &&
                      item.medalsIcon.map((item, index) => <img className="medal-item" key={index} src={item} />)}
                  </div>
                  <div className="id-time">ID: {item.duid}</div>
                </div>
                <div
                  className={`${language == 'ar' ? 'invtie-btn-ar' : 'invtie-btn'}`}
                  onClick={() => this.invtieUser(item.uid)}
                >
                  {lang.invtieText}
                </div>
              </div>
            ))}
          </div>
        )}
        {setSeachValue.length > 0 && invtiList.length == 0 && (
          <div className="empty-root">
            <img className="empty-root-img"  src="img/app/newhost/empty_img.png"></img>
            <div className="empty-text">{this.state.lang.searchEmptyTrxt}</div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/invite-member/index.js